import ConfigurationForCarbonType from "./ConfigurationForCarbonType";

class CarbonElementType {
    public id: string = ""
    public configurationsForCarbon: Array<ConfigurationForCarbonType> = new Array<ConfigurationForCarbonType>();
    public distancePerYear = 0
    public requiredcii = new Array<number>();
}

export default CarbonElementType